<template>
  <div class="sa-edition-form">
    <v-alert
      v-model="alert"
      dismissible
      color="error"
      border="left"
      elevation="2"
      colored-border
      icon="priority_high"
    >An error happened while saving: {{errorDisplay(updateError)}}</v-alert>
    <v-row no-gutters>
      <v-btn class="my-4 mx-1" :color="editable ? 'error': 'primary'" @click="cancelEdition">
        <v-icon dark left>{{editable ? 'cancel' : 'mdi-pencil'}}</v-icon>
        {{ editable ? 'Cancel' : 'Edit' }}
      </v-btn>
      <v-btn class="my-4 mx-1" color="success" v-if="editable" @click="save">
        <v-icon dark left>save</v-icon>Save
      </v-btn>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" md="6">
        <v-text-field
          label="uuid"
          placeholder="uuid"
          outlined
          dense
          v-model="newUuid"
          disabled
          class="pa-1"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          label="id*"
          placeholder="ID..."
          outlined
          v-model="newId"
          :rules="[rules.min3, rules.startsWithServiceAccount]"
          required
          dense
          :disabled="!editable"
          class="pa-1"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field
          label="name*"
          placeholder="Name..."
          outlined
          v-model="newName"
          :rules="[rules.min3]"
          required
          dense
          :disabled="!editable"
          class="pa-1"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-textarea
      label="description"
      placeholder="Description..."
      class="pa-1"
      rows="2"
      outlined
      :maxlength="130"
      dense
      no-resize
      :disabled="!editable"
      v-model="newDescription"
    ></v-textarea>
  </div>
</template>

<script>
import mixin from "@/mixins";
import { mapState } from "vuex";
export default {
  mixins: [mixin],
  props: {
    uuid: { type: String },
    id: { type: String },
    name: { type: String },
    description: { type: String }
  },
  data() {
    return {
      editable: false,
      alert: false,
      newUuid: "",
      newId: "",
      newName: "",
      newDescription: "",
      rules: {
        min3: v =>
          v.length >= 3 ||
          "This field is required, and must contain 3 letters at least",
        min6: v =>
          v.length >= 6 ||
          "This field is required, and must contain 6 letters at least",
        startsWithServiceAccount: v =>
          v.startsWith("sa-") ||
          "This field is required, and must contain 3 letters at least"
      }
    };
  },
  computed: {
    ...mapState({
      updateError: state => state.serviceAccounts.updateOne.error,
      updateLoading: state => state.serviceAccounts.updateOne.pending
    })
  },
  watch: {
    uuid() {
      this.newUuid = this.uuid;
    },
    id() {
      this.newId = this.id;
    },
    name() {
      this.newName = this.name;
    },
    description() {
      this.newDescription = this.description;
    },
    updateError() {
      if (this.updateError) {
        this.alert = true;
      } else {
        this.alert = false;
      }
    }
  },
  methods: {
    cancelEdition() {
      if (this.editable) {
        this.newUuid = this.uuid;
        this.newId = this.id;
        this.newName = this.name;
        this.newDescription = this.description;
      }
      this.editable = !this.editable;
    },
    save() {
      this.$emit("save", this.newId, this.newName, this.newDescription);
    },
    saveCallback() {
      this.editable = false;
    }
  }
};
</script>

<style>
</style>